
<app-modal  [modalSize]="modalSize" [modalText]="props.modalShareText" (modalClose)="close($event)">
    <div class="user-text">
        <form>
            <div class="d-flex">
                <label class="w-50 lblGroup">Select Groups </label>
                <div *ngIf="props.dashboardType == 1">
                    <input class="w-50" id="typeahead-prevent-manual-entry" aria-label="Search" type="text" class="form-control search-width"
                name="searchUserInstance" [(ngModel)]="setSelectedUser" [ngbTypeahead]="searchUser"
                [inputFormatter]="searchUserformatter" [resultFormatter]="searchUserformatter"
                [editable]='false' #searchUserInstance />
                </div>
                <div *ngIf="props.dashboardType != 1">
                <input class="w-50" id="typeahead-prevent-manual-entry" aria-label="Search" type="text" class="form-control search-width"
                name="searchUserInstance" [(ngModel)]="setSelectedGroup" [ngbTypeahead]="searchUser"
                [inputFormatter]="searchGroupformatter" [resultFormatter]="searchGroupformatter"
                [editable]='false' #searchUserInstance />
                </div>
            </div>           
        </form>
    </div>
   
    <div class="result-view">
        <span *ngIf="props.dashboardType != 1">
            <mat-chip-listbox aria-label="Chip Listbox" *ngFor="let group of selectedGroupList;let i = index">
                <mat-chip-option (removed)="removeGroup(selectedGroupList,i)">{{group.groupName}}<mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-option>
            </mat-chip-listbox>
        </span>
        <span *ngIf="props.dashboardType == 1" >
            <mat-chip-listbox aria-label="Chip Listbox" *ngFor="let group of userInfo.groups;let i = index">
                <mat-chip-option (removed)="removeUser(userInfo.groups, i)">{{group.groupName}}<mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-option>
            </mat-chip-listbox>
            <mat-chip-listbox aria-label="Chip Listbox" *ngFor="let user of userInfo.users;let i = index">
                <mat-chip-option (removed)="removeGroup(userInfo.users, i)">{{user.fullName}}<mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-option>
            </mat-chip-listbox>
        </span>
    </div>
    <br />
    <div class="flex-end pb-2">
        <div class="modal-footer">                  
            <button *ngIf="props.dashboardType != 1" [disabled]="selectedGroupList.length == 0" [style.opacity]="selectedGroupList.length == 0 ? '0.6' : ''"
            class="share-btn"   (click)="emitSaveAction($event)">Share</button> &nbsp;
            <button *ngIf="props.dashboardType == 1" [disabled]="userInfo.users.length == 0 && userInfo.groups.length == 0" [style.opacity]="userInfo.users.length == 0 && userInfo.groups.length == 0 ? '0.6' : ''"
            class="share-btn"   (click)="emitSaveAction($event)">Share</button> &nbsp;
            <button class="back-btn"  (click)="close($event)">Back</button> &nbsp;                    
        </div> 
    </div>
</app-modal>

